import React from 'react';

const WebsiteAnalyticsHeader: React.FC = () => {
  return null;
};

export { WebsiteAnalyticsHeader };
